module.exports = {"audiences":["allMembers","alphaMembers"],"experimentVersion":"v1","experimentAllocation":{"englishMembers":0.2,"alphaEnglishMembers":1},"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/requestToJoin.json
// module id = IN6/
// module chunks = 2